import { Block, Button, Icon } from "framework7-react";
import ScaleIcon from "../../components/scale-icon";
import { getSettlementStatus } from "../../utils/settlement-status";

const SettlementButton = ({ participants, meId, onClick }) => {
  const status = getSettlementStatus(participants, meId);
  return (
    <Block inset className="settlement-entry">
      <Button
        fill={!status.settled}
        tonal={status.settled}
        large
        className={`settlement-button${
          status.settled ? " settlement-button-settled" : ""
        }`}
        onClick={onClick}
      >
        <ScaleIcon />
        <span className="settlement-button-text">
          <span className="settlement-button-label">Abrechnen</span>
          <span className="settlement-button-status">
            <span className="settlement-button-count">{status.text}</span>
            {status.personal && (
              <>
                {" · "}
                <span className="settlement-button-personal">
                  {status.personal.text}
                </span>
              </>
            )}
          </span>
        </span>
        <Icon
          className="settlement-button-chevron"
          ios="f7:chevron_right"
          md="material:chevron_right"
          size={20}
        />
      </Button>
    </Block>
  );
};

export default SettlementButton;
